export const calculateResults = (inputs) => {
    const {
      averageSolarIrradiance,
      coolingDaysPerYear,
      hoursPerDay,
      roofArea,
      existingAlbedo,
      coolAlbedo,
      cop,
      costPerKWh,
      materialCostPerM2,
      laborCostPerM2,
      emissionFactor,
      serviceLife,
      annualDegradation
    } = inputs;
  
    // 1) Heat Gain Reduction (W/m²)
    const deltaAlbedo = coolAlbedo - existingAlbedo;
    const heatReductionPerM2 = averageSolarIrradiance * deltaAlbedo;
    const totalHeatReductionW = heatReductionPerM2 * roofArea;
  
    // 2) Annual Heat Reduction (kWh)
    const annualHeatKWh = (totalHeatReductionW * coolingDaysPerYear * hoursPerDay) / 1000;
  
    // 3) Cooling Load Reduction (kWh/year)
    const coolingLoadReductionKWh = cop > 0 ? annualHeatKWh / cop : 0;
  
    // 4) Annual Cost Savings
    const annualSavings = coolingLoadReductionKWh * costPerKWh;
  
    // 5) Total Application Cost (material + labor)
    const materialCostTotal = roofArea * materialCostPerM2;
    const laborCostTotal = roofArea * laborCostPerM2;
    const totalApplicationCost = materialCostTotal + laborCostTotal;
  
    // 6) ROI & Payback
    const roiPercent = totalApplicationCost > 0 ? (annualSavings / totalApplicationCost) * 100 : 0;
    const paybackYears = annualSavings > 0 ? totalApplicationCost / annualSavings : 0;
  
    // 7) CO₂ Reduction
    const co2ReductionKg = coolingLoadReductionKWh * emissionFactor;
    const co2ReductionTonnes = co2ReductionKg / 1000;
  
    // 8) Lifetime Savings (no discounting)
    const totalLifetimeSavings = annualSavings * serviceLife;
  
    return {
      heatReductionPerM2: heatReductionPerM2.toFixed(2),
      totalHeatReductionW: totalHeatReductionW.toFixed(2),
      annualHeatKWh: annualHeatKWh.toFixed(2),
      coolingLoadReductionKWh: coolingLoadReductionKWh.toFixed(2),
      annualSavings: annualSavings.toFixed(2),
      totalApplicationCost: totalApplicationCost.toFixed(2),
      roiPercent: roiPercent.toFixed(2),
      paybackYears: paybackYears.toFixed(2),
      co2ReductionKg: co2ReductionKg.toFixed(2),
      co2ReductionTonnes: co2ReductionTonnes.toFixed(2),
      totalLifetimeSavings: totalLifetimeSavings.toFixed(2),
      serviceLife,
      annualDegradation
    };
  };
 
